const apiUrlMiddleware = ({ dispatch }) => next => async action => {
  const result = next(action);
  if (action.apiMethod) {
    const output = await action.apiMethod;
    if (output && output.error) dispatch(action.failure(output.error, action.failedParam));
    else dispatch(action.success(output, action.sucessParam));
  }

  return result;
};

export default apiUrlMiddleware;
